import styled from "@emotion/styled";
import type { FunctionComponent } from "react";

const Component: FunctionComponent = () => <br />;

Component.displayName = "Br";

export const Br = styled(Component)``;
